export const createFilterBasedOnEventType = () => {
  return {
    id: "event_type",
    label: "Event Type",
    options: [
      { label: "API Call", value: "api_call" },
      { label: "RPA Actions", value: "rpa_action" },
      { label: "User Action", value: "frontend_event" },
    ],
    type: "string" as const,
  };
};
